import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import type { IReferencesState } from '../types';
import { api } from '../api/client';

const initialState: IReferencesState = {
    data: null,
    loading: false,
    loaded: false,
};

export const fetchReferences = createAsyncThunk(
    'references/fetch',
    async (_, { rejectWithValue }) => {
        try {
            return await api.getReferences();
        } catch (e: any) {
            return rejectWithValue(e.message);
        }
    }
);

const referencesSlice = createSlice({
    name: 'references',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchReferences.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchReferences.fulfilled, (state, action) => {
                state.loading = false;
                state.loaded = true;
                state.data = action.payload;
            })
            .addCase(fetchReferences.rejected, (state, action) => {
                state.loading = false;
                console.error('Failed to load references:', action.payload || action.error);
            });
    },
});

export default referencesSlice.reducer;
